import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { AlertFilters } from '../hooks/use-insights'

interface AlertsFiltersProps {
  filters: AlertFilters
  onFiltersChange: (filters: AlertFilters) => void
}

export function InsightsFiltersComponent({
  filters,
  onFiltersChange,
}: AlertsFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      <Select
        value={filters.status ?? 'active'}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            status: value as AlertFilters['status'],
          })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="active">Ativos</SelectItem>
          <SelectItem value="acted_on">Resolvidos</SelectItem>
          <SelectItem value="dismissed">Dispensados</SelectItem>
          <SelectItem value="all">Todos</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.severity ?? 'all'}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            severity: value as AlertFilters['severity'],
          })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Severidade" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas severidades</SelectItem>
          <SelectItem value="critical">Crítica</SelectItem>
          <SelectItem value="high">Alta</SelectItem>
          <SelectItem value="medium">Média</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
